import { render, staticRenderFns } from "./CampaignStatsTableV2.vue?vue&type=template&id=58790804&"
import script from "./CampaignStatsTableV2.vue?vue&type=script&lang=js&"
export * from "./CampaignStatsTableV2.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatsTableV2.vue?vue&type=style&index=0&id=58790804&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports